import { render, staticRenderFns } from "./RetrievedEmailVerification.vue?vue&type=template&id=4f334a8d&"
import script from "./RetrievedEmailVerification.vue?vue&type=script&lang=ts&"
export * from "./RetrievedEmailVerification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports